import React, { useEffect, useState } from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import colors from '../../themes/main-colors';
import WarningIcon from '@material-ui/icons/Warning';
import { useTranslation } from '../../hooks/useTranslation';

type Props = {
  title: string;
  hide?: boolean;
};

const { t } = useTranslation();

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    title: {
      paddingBottom: 16,
      display: 'block',
    },
    colorTextPrimary: {
      color: colors.noirBlur,
    },
    warningIcon: {
      color: '#c42525',
    },
    position: {
      textAlign: 'center',
    },
  }),
);

function ErrorOverlay({ title, hide }: Props) {
  const classes = useStyles();

  return (
    <Grid>
      {!hide && (
        <Typography
          className={clsx(classes.colorTextPrimary, classes.title)}
          component="span"
          variant="h2"
        >
          {title}
        </Typography>
      )}
      <Grid item className={classes.position}>
        <div>
          <WarningIcon className={classes.warningIcon} />
        </div>
        <p>
          {title} {t('COMPONENT_IS_DOWN')}
        </p>
      </Grid>
    </Grid>
  );
}

export default ErrorOverlay;
